import React from 'react';

export const S3_API_URL = '/admin/api/s3/list';
export const S3_DEFAULT_UPLOAD_FOLDER = 'uploads';


export const recoveryExpertiseIcons = [
  {
    name: 'trophy',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path
          fill="#92400e"
          d="M14.5 3.75h-1.25V3a.75.75 0 0 0-.75-.75h-9a.75.75 0 0 0-.75.75v.75H1.5A1.25 1.25 0 0 0 .25 5v1A2.753 2.753 0 0 0 3 8.75h.048a5.26 5.26 0 0 0 4.202 3.447v1.053H6a.75.75 0 1 0 0 1.5h4a.75.75 0 1 0 0-1.5H8.75v-1.056c1.934-.282 3.533-1.637 4.188-3.444H13A2.753 2.753 0 0 0 15.75 6V5a1.25 1.25 0 0 0-1.25-1.25M1.75 6v-.75h1V7q-.002.113.006.226A1.25 1.25 0 0 1 1.75 6m10 .944c0 2.083-1.67 3.79-3.721 3.806A3.75 3.75 0 0 1 4.25 7V3.75h7.5zM14.25 6a1.25 1.25 0 0 1-1.008 1.226q.008-.14.008-.282V5.25h1z"
        />
      </svg>
    ),
  },
  {
    name: 'money',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 15">
        <path
          fill="#92400e"
          d="M15.398 3.314a.79.79 0 0 0-.727-.036c-2.593 1.19-4.463.628-6.442.033-2.074-.622-4.424-1.328-7.558.11a.74.74 0 0 0-.307.259.67.67 0 0 0-.114.372v7.038c0 .119.032.236.094.34q.094.16.259.256a.79.79 0 0 0 .726.036c2.593-1.19 4.463-.628 6.442-.033 1.177.351 2.443.733 3.89.733 1.104 0 2.313-.221 3.668-.842a.74.74 0 0 0 .307-.26.67.67 0 0 0 .114-.372V3.91a.67.67 0 0 0-.094-.342.7.7 0 0 0-.258-.255m-1.148 7.181c-2.375.947-4.15.415-6.021-.147-1.177-.351-2.443-.733-3.89-.733a8.3 8.3 0 0 0-2.589.419v-5.53c2.375-.946 4.15-.414 6.021.148 1.829.549 3.872 1.162 6.479.314zM8 5.625c-.396 0-.782.11-1.111.316a1.9 1.9 0 0 0-.737.842c-.151.342-.19.72-.114 1.083.078.364.268.698.548.96s.636.44 1.024.513c.388.072.79.035 1.155-.107.366-.142.678-.382.898-.69.22-.309.337-.671.337-1.042a1.82 1.82 0 0 0-.587-1.325A2.07 2.07 0 0 0 8 5.625M8 7.97a.52.52 0 0 1-.278-.08.48.48 0 0 1-.184-.21.44.44 0 0 1-.028-.27.46.46 0 0 1 .136-.24.531.531 0 0 1 .545-.102c.092.035.17.096.225.173a.45.45 0 0 1-.062.592.52.52 0 0 1-.354.137m-4-2.11v2.344a.68.68 0 0 1-.22.497.78.78 0 0 1-.53.206.78.78 0 0 1-.53-.206.68.68 0 0 1-.22-.497V5.86c0-.186.079-.365.22-.497a.78.78 0 0 1 .53-.206c.199 0 .39.074.53.206s.22.311.22.497m8 3.282V6.797c0-.187.079-.365.22-.497a.78.78 0 0 1 .53-.206c.199 0 .39.074.53.206s.22.31.22.497V9.14a.68.68 0 0 1-.22.497.78.78 0 0 1-.53.206.78.78 0 0 1-.53-.206.68.68 0 0 1-.22-.497"
        />
      </svg>
    ),
  },
  {
    name: 'grid-flag',
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path
          fill="#92400e"
          d="M14.313 2.813a.75.75 0 0 0-.804.115c-1.544 1.338-2.783.831-4.676-.105C7.074 1.954 4.886.87 2.51 2.93a.75.75 0 0 0-.259.57V14a.75.75 0 1 0 1.5 0v-2.643c1.428-1.07 2.631-.57 4.418.313 1.014.5 2.17 1.075 3.425 1.075.92 0 1.892-.31 2.898-1.18A.75.75 0 0 0 14.75 11V3.5a.75.75 0 0 0-.437-.687m-2.72 2.431c.572.001 1.138-.123 1.657-.364v2.01c-.687.516-1.325.666-2 .585V5.23q.17.015.342.015M9.75 4.88v2.13c-.29-.124-.594-.274-.917-.437a16 16 0 0 0-1.583-.709v-2.13c.29.125.594.275.918.438q.771.398 1.582.708m-4-1.61v2.245a3.96 3.96 0 0 0-2 .35v-2.01c.688-.516 1.325-.667 2-.585m-.342 5.98c-.573 0-1.139.125-1.658.366v-2.01c.688-.515 1.325-.666 2-.585v2.247a4 4 0 0 0-.342-.018m1.842.366v-2.13c.29.125.594.275.918.437q.771.397 1.582.708v2.131q-.434-.193-.917-.437a16 16 0 0 0-1.583-.709m4 1.61V8.98q.17.014.342.015c.573 0 1.139-.124 1.658-.366v2.012c-.687.517-1.325.667-2 .585"
        />
      </svg>
    ),
  },
];

export const injuries = [
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 12">
        <path
          fill="currentColor"
          d="M14.75 4.5h-.512L12.568.743A1.25 1.25 0 0 0 11.425 0h-7.35a1.25 1.25 0 0 0-1.142.743L1.263 4.5H.75a.75.75 0 0 0 0 1.5H1v4.75A1.25 1.25 0 0 0 2.25 12H4a1.25 1.25 0 0 0 1.25-1.25V9.5h5v1.25A1.25 1.25 0 0 0 11.5 12h1.75a1.25 1.25 0 0 0 1.25-1.25V6h.25a.75.75 0 1 0 0-1.5m-10.512-3h7.024l1.334 3H2.904zm-.488 9H2.5v-1h1.25zm8 0v-1H13v1zM13 8H2.5V6H13z"
        />
      </svg>
    ),
    label: 'Vehicle Accident',
    value: 1,
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path
          fill="currentColor"
          d="m14.559 10.191-1.789-.894a2.74 2.74 0 0 1-1.52-2.46V5a.75.75 0 0 0-.75-.75A2.753 2.753 0 0 1 7.75 1.5.75.75 0 0 0 6.547.902L1.734 4.553l-.018.014a1.25 1.25 0 0 0-.098 1.856l7.105 7.108a.75.75 0 0 0 .53.219H14a1.25 1.25 0 0 0 1.25-1.25v-1.191a1.24 1.24 0 0 0-.691-1.118m-.809 2.059H9.563L2.88 5.565l.804-.61L6.259 7.53A.751.751 0 1 0 7.32 6.468L4.891 4.04l1.577-1.196a4.26 4.26 0 0 0 3.282 2.84v1.153a4.23 4.23 0 0 0 2.35 3.801l1.65.826zM3.468 11.5H2A.75.75 0 0 1 2 10h1.468a.75.75 0 0 1 0 1.5m3 1.5a.75.75 0 0 1-.75.75H3a.75.75 0 0 1 0-1.5h2.718a.75.75 0 0 1 .75.75"
        />
      </svg>
    ),
    label: 'Slip and fall',
    value: 6,
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path
          fill="currentColor"
          d="M13.5 3.75h-2.26a3.25 3.25 0 0 0-6.48 0H2.5A1.25 1.25 0 0 0 1.25 5v7.5a1.25 1.25 0 0 0 1.25 1.25h11a1.25 1.25 0 0 0 1.25-1.25V5a1.25 1.25 0 0 0-1.25-1.25M8 2.25a1.75 1.75 0 0 1 1.732 1.5H6.268A1.75 1.75 0 0 1 8 2.25m5.25 10H2.75v-7h10.5z"
        />
      </svg>
    ),
    label: 'Work accident',
    value: 2,
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path
          d="M14.75 6.75C14.75 7.04667 14.662 7.33668 14.4972 7.58336C14.3324 7.83003 14.0981 8.02229 13.824 8.13582C13.5499 8.24935 13.2483 8.27906 12.9574 8.22118C12.6664 8.1633 12.3991 8.02044 12.1893 7.81066C11.9796 7.60088 11.8367 7.33361 11.7788 7.04264C11.7209 6.75167 11.7507 6.45007 11.8642 6.17598C11.9777 5.90189 12.17 5.66762 12.4166 5.5028C12.6633 5.33797 12.9533 5.25 13.25 5.25C13.6478 5.25 14.0294 5.40804 14.3107 5.68934C14.592 5.97065 14.75 6.35218 14.75 6.75ZM4.25 6.75C4.25 6.45333 4.16203 6.16332 3.99721 5.91665C3.83238 5.66997 3.59811 5.47771 3.32403 5.36418C3.04994 5.25065 2.74834 5.22094 2.45737 5.27882C2.16639 5.3367 1.89912 5.47956 1.68934 5.68934C1.47956 5.89912 1.3367 6.16639 1.27882 6.45737C1.22094 6.74834 1.25065 7.04994 1.36418 7.32403C1.47771 7.59812 1.66997 7.83238 1.91665 7.99721C2.16332 8.16203 2.45333 8.25 2.75 8.25C3.14783 8.25 3.52936 8.09197 3.81066 7.81066C4.09197 7.52936 4.25 7.14783 4.25 6.75ZM5.75 5.25C6.04667 5.25 6.33668 5.16203 6.58336 4.99721C6.83003 4.83238 7.02229 4.59811 7.13582 4.32403C7.24935 4.04994 7.27906 3.74834 7.22118 3.45737C7.1633 3.16639 7.02044 2.89912 6.81066 2.68934C6.60088 2.47956 6.33361 2.3367 6.04264 2.27882C5.75166 2.22094 5.45006 2.25065 5.17598 2.36418C4.90189 2.47771 4.66762 2.66997 4.5028 2.91665C4.33797 3.16332 4.25 3.45333 4.25 3.75C4.25 4.14783 4.40804 4.52936 4.68934 4.81066C4.97064 5.09197 5.35218 5.25 5.75 5.25ZM10.25 5.25C10.5467 5.25 10.8367 5.16203 11.0834 4.99721C11.33 4.83238 11.5223 4.59811 11.6358 4.32403C11.7494 4.04994 11.7791 3.74834 11.7212 3.45737C11.6633 3.16639 11.5204 2.89912 11.3107 2.68934C11.1009 2.47956 10.8336 2.3367 10.5426 2.27882C10.2517 2.22094 9.95006 2.25065 9.67598 2.36418C9.40189 2.47771 9.16762 2.66997 9.0028 2.91665C8.83797 3.16332 8.75 3.45333 8.75 3.75C8.75 4.14783 8.90804 4.52936 9.18934 4.81066C9.47064 5.09197 9.85218 5.25 10.25 5.25ZM13.25 11.5C13.2501 11.9538 13.1379 12.4005 12.9234 12.8004C12.7089 13.2003 12.3988 13.5409 12.0207 13.7919C11.6426 14.0428 11.2082 14.1963 10.7564 14.2386C10.3046 14.2809 9.84937 14.2107 9.43125 14.0344C8.51442 13.6569 7.48558 13.6569 6.56875 14.0344C5.91818 14.3093 5.18677 14.3235 4.52608 14.0738C3.86539 13.8241 3.32608 13.3298 3.01993 12.6934C2.71378 12.0569 2.66426 11.327 2.88163 10.655C3.099 9.98298 3.56659 9.42037 4.1875 9.08375C4.64097 8.83214 4.97611 8.41091 5.11938 7.9125C5.30077 7.28885 5.67966 6.74091 6.19911 6.35103C6.71856 5.96114 7.35051 5.75036 8 5.75036C8.64949 5.75036 9.28145 5.96114 9.80089 6.35103C10.3203 6.74091 10.6992 7.28885 10.8806 7.9125C11.024 8.41088 11.3591 8.83209 11.8125 9.08375C12.2473 9.31992 12.6104 9.66903 12.8634 10.0943C13.1164 10.5195 13.2499 11.0052 13.25 11.5ZM11.75 11.5C11.7501 11.2746 11.6892 11.0533 11.5737 10.8597C11.4583 10.666 11.2927 10.5072 11.0944 10.4L11.0881 10.3963C10.2871 9.95436 9.69431 9.21251 9.44 8.33375C9.34912 8.02218 9.15964 7.74848 8.9 7.55375C8.64036 7.35902 8.32456 7.25375 8 7.25375C7.67545 7.25375 7.35964 7.35902 7.1 7.55375C6.84036 7.74848 6.65088 8.02218 6.56 8.33375C6.43447 8.76946 6.2243 9.17615 5.94151 9.53059C5.65871 9.88502 5.30883 10.1802 4.91188 10.3994L4.90563 10.4031C4.66234 10.5361 4.47017 10.7461 4.35932 11.0003C4.24848 11.2544 4.22527 11.5381 4.29334 11.8069C4.3614 12.0757 4.51688 12.3142 4.73532 12.4849C4.95376 12.6556 5.22276 12.7489 5.5 12.75C5.66751 12.7505 5.83337 12.7169 5.9875 12.6513H5.99563C7.27927 12.121 8.72073 12.121 10.0044 12.6513H10.0125C10.1666 12.7169 10.3325 12.7505 10.5 12.75C10.8315 12.75 11.1495 12.6183 11.3839 12.3839C11.6183 12.1495 11.75 11.8315 11.75 11.5Z"
          fill="currentColor"
        />
      </svg>
    ),
    label: 'Animal attack',
    value: 4,
  },
  {
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
        <path
          fill="currentColor"
          d="M13.25 4.25h-11V3a.75.75 0 0 0-1.5 0v10a.75.75 0 1 0 1.5 0v-1.75H14.5V13a.75.75 0 1 0 1.5 0V7a2.753 2.753 0 0 0-2.75-2.75m-7 5.5h-4v-4h4zm8.25 0H7.75v-4h5.5A1.25 1.25 0 0 1 14.5 7z"
        />
      </svg>
    ),
    label: 'Nursing home abuse',
    value: 5,
  },
  {
    icon: null,
    label: 'Other',
    value: 7,
  },
];

export const consent = `I consent to receive communications from Johnson Law Group regarding my claim, including calls, texts, emails, and prerecorded messages which may be sent using automated technology and agree to the  <a style="text-decoration:underline;" href="https://www.johnsonlawgroup.com/legal/privacy-policy">Terms and Privacy Policy</a>.`;

export const PageTypes = {
  RootLevel: 'root-level',
  GeneralContent: 'general-content',
  Location: 'location',
  ClaimType: 'claim-type',
  ClamSection: 'claim-section',
} as const;

export type PageTypeTypes = (typeof PageTypes)[keyof typeof PageTypes];

export const CAR_ACCIDENT = 'Car Accident';
export const MOTORCYCLE_ACCIDENT = 'Motorcycle Accident';
export const BICYCLE_ACCIDENT = 'Bicycle Accident';
export const DOG_BITES = 'Dog Bites';
export const TRUCK_ACCIDENT = 'Truck Accident';
export const MEDICAL_MALPRACTICE = 'Medical Malpractice';
export const NURSING_HOME_ABUSE = 'Nursing Home Abuse';
export const WORKPLACE_ACCIDENT = 'Workplace accident';
export const SLIP_AND_FALL = 'Slip and fall';
export const PEDESTRIAN_ACCIDENT = 'Pedestrian accident';

export type PersonalInjuryType =
  | typeof CAR_ACCIDENT
  | typeof MOTORCYCLE_ACCIDENT
  | typeof BICYCLE_ACCIDENT
  | typeof DOG_BITES
  | typeof TRUCK_ACCIDENT
  | typeof MEDICAL_MALPRACTICE
  | typeof NURSING_HOME_ABUSE
  | typeof WORKPLACE_ACCIDENT
  | typeof SLIP_AND_FALL
  | typeof PEDESTRIAN_ACCIDENT;

export const AccidentTypesIcons = [
  'rear-end-collision',
  't-bone-accident',
  'head-on-collision',
  'multi-vehicle-accident',
  'hit-and-run-accident',
  'semi-truck-accident',
  'delivery-truck-accident',
  'amazon-delivery-van',
  'dump-truck-accident',
  'box-truck-accident',
  'blind-spot-accident',
  'left-turn-accident',
  'distracted-driver-accident',
  'lane-change-accident',
  'dooring-accident',
  'intersection-accident',
  'unsafe-road-conditions',
  'right-hook-accident',
  'crosswalk-accident',
  'turning-vehicle-accident',
  'parking-lot-accident',
  'breaking-up-accident',
  'wet-slippery-floors',
  'uneven-surface-accident',
  'stairway-accident',
  'workplace-slip-falls',
  'parking-lot-sidewalk-falls',
  'medical-malpractice',
  'defective-products',
  'brain',
  'drop',
  'cracked-egg',
  'user-sound',
  'wind',
];
